import actionTypes from './index';

export default designId => ({ type: actionTypes.REMOVE_ESTIMATE, payload: { designId } });
